import { render, staticRenderFns } from "./reviewListPage.vue?vue&type=template&id=fd547896&scoped=true&"
import script from "./reviewListPage.vue?vue&type=script&lang=js&"
export * from "./reviewListPage.vue?vue&type=script&lang=js&"
import style0 from "./reviewListPage.vue?vue&type=style&index=0&id=fd547896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd547896",
  null
  
)

export default component.exports